import styled from 'styled-components';
import { fontSize, screen } from 'theme';

const Root = styled.div`
  background-color: #faf9ff;
  color: #433f52;
  padding: 24px 1rem;
  font-size: ${fontSize('lg')};
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media (min-width: ${screen('lg')}) {
    padding: 64px 0;
  }

  .intro {
    margin-bottom: 2rem;

    @media (min-width: ${screen('lg')}) {
      max-width: 70%;
      margin-left: auto;
      margin-right: auto;

      &.full {
        max-width: 100%;
      }
    }
  }
`;

const CardContent1 = styled.div<{ align?: 'left' | 'center' | 'right' }>`
  font-size: ${fontSize('lg')};
  line-height: 1.75;

  h3 {
    margin: 0 0 0.5rem 0;
    font-size: ${fontSize('xl')};
    font-weight: 700;
    line-height: 1.25;
  }

  p {
    margin-top: 0;
    font-size: ${fontSize('md')};
  }

  p:last-child {
    margin-bottom: 0;
  }

  @media (min-width: ${screen('lg')}) {
    max-width: ${({ align }) => (align === 'center' ? '55%' : '100%')};
    text-align: ${({ align }) => align || 'left'};
    margin: 0 auto;

    h3 {
      font-size: ${fontSize('xl3')};
    }

    p {
      font-size: ${fontSize('lg')};
    }
  }
`;

const CardContent2 = styled.div<{ align?: 'left' | 'center' | 'right' }>`
  font-size: ${fontSize('lg')};
  line-height: 1.75;

  img {
    margin-bottom: 2rem;
  }

  h3 {
    margin: 0 0 0.5rem 0;
    font-size: ${fontSize('xl')};
    font-weight: 700;
    line-height: 1.25;
  }

  p {
    margin-top: 0;
    font-size: ${fontSize('md')};
  }

  p:last-child {
    margin-bottom: 0;
  }

  @media (min-width: ${screen('lg')}) {
    max-width: ${({ align }) => (align === 'center' ? '55%' : '100%')};
    text-align: ${({ align }) => align || 'left'};
    margin: 0 auto;

    h3 {
      font-size: ${fontSize('xl3')};
    }

    p {
      font-size: ${fontSize('lg')};
    }
  }
`;

export const TalentToolsStyles = {
  Root,
  CardContent1,
  CardContent2
};
